// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReplayModal_modal__3J9jn","title":"ReplayModal_title__1xx1M","description":"ReplayModal_description__CFRz7"};